import {
  View,
  Text,
  TextInput,
  StyleSheet,
  TouchableOpacity,
} from "react-native";
import React, { useState, useEffect } from "react";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";

import { Ionicons } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import Serie from "../Firestore/Serie";
import { observer, Observer } from "mobx-react";
import { reaction } from "mobx";
import { Menu, MenuItem, MenuDivider } from "react-native-material-menu";

import { useScreenDimensions, useDevice } from "../_layout";

import { useTranslation } from "react-i18next";
import ImageMessageManager from "../Classes/ImageMessageManager";
import MediaManager from "../Classes/MediaManager";
import NetworkManager from "../Classes/NetworkManager";
import { formatNumber1Dec, formatNumber2Dec } from "../utils/numberUtils";
import Tooltip from "../Components/Tooltip";

const SerieRowView = ({ serie, showSetPriority }) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();

  const PropertyCases = {
    weight: "weight",
    reps: "reps",
    rpe: "rpe",
    targetWeight: "targetWeight",
    targetReps: "targetReps",
    targetRpe: "targetRpe",
  };

  const [refresh, setRefresh] = useState(false);
  const { screenSize } = useScreenDimensions();
  useEffect(() => {
    const dispose = reaction(
      () => ({
        updateSets: serie.exercise.updateSets,
        updateSet: serie.updateSet,
      }),
      () => {
        setRefresh((prev) => !prev);
      }
    );

    return () => dispose();
  }, [serie.exercise]);

  const TextBox = ({ property, propertyCase }) => {
    const isTargetCase = [
      PropertyCases.targetWeight,
      PropertyCases.targetReps,
      PropertyCases.targetRpe,
    ].includes(propertyCase);

    const initialValue =
      typeof property === "string"
        ? property
        : property !== 0 && property != null
        ? formatNumber1Dec(property)
        : "";

    const [propertyString, setPropertyString] = useState(initialValue);

    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
      setPropertyString(
        typeof property === "string"
          ? property
          : property !== 0 && property !== null
          ? formatNumber1Dec(property)
          : ""
      );
      // if (isTargetCase) {
      //   setPropertyString( typeof property === "string"
      //   ? property
      //   : property !== 0 && property != null
      //   ? formatNumber1Dec(property)
      //   : "");
      // } else {
      //   if (property > 0) {
      //     setPropertyString(String(formatNumber(property)));
      //   }
      // }
    }, [refresh]);

    const handleChange = (text) => {
      const formattedText = text.replace(",", ".");

      if (
        propertyCase === PropertyCases.targetWeight ||
        propertyCase === PropertyCases.targetReps ||
        propertyCase === PropertyCases.targetRpe
      ) {
        setPropertyString(formattedText);
        serie.setProperty(propertyCase, formattedText);
        return;
      }

      const aux = Number(formattedText);

      if (!isNaN(aux)) {
        setPropertyString(formattedText);

        let numAux;
        if (formattedText === "") {
          numAux = Number(formattedText);
        } else {
          numAux = Number(formattedText) + 0.0000001;
        }

        // let numAux = Number(formattedText);

        if (propertyCase === PropertyCases.weight) {
          serie.setProperty("weight", numAux);
        } else if (propertyCase === PropertyCases.reps) {
          serie.setProperty("reps", Math.round(numAux));
        } else if (propertyCase === PropertyCases.rpe) {
          serie.setProperty("rpe", numAux);
        }
      }
    };

    const getBackgroundColor = (serie) => {
      if (!serie) return "transparent";

      const target = serie.getTargetRpeReference;
      const actual = serie.rpe;

      if (typeof target === "number" && target > 0.02 && actual > 0.02) {
        // round both to one decimal (to match your formatNumber logic)
        const a = parseFloat(formatNumber2Dec(actual));
        const t = parseFloat(formatNumber2Dec(target));

        if (Math.abs(a - t) >= 1) {
          return a > t
            ? "rgba(240, 68, 56, 0.15)" // too heavy
            : "rgba(93, 196, 96, 0.15)"; // too light
        }
      }

      return "transparent";
    };

    const isActualEmpty =
      !isTargetCase && (propertyString == null || propertyString.trim() === "");

    const effectiveBorderColor = isHovered
      ? isActualEmpty
        ? "rgb(200,200,200)"
        : "gray"
      : isActualEmpty
      ? Colors.borderColor
      : Colors.grayColor;

    return (
      <View
        style={{
          borderColor: effectiveBorderColor,
          width: screenSize === "small" ? "13%" : "11%",
          height: screenSize === "small" ? 21 : 24,
          borderRadius: screenSize === "small" ? 8 : 10,
          borderWidth: isHovered ? 1.2 : 1,
          justifyContent: "center",
          alignItems: "center",
          maxWidth: 56,
          backgroundColor:
            propertyCase === PropertyCases.rpe && getBackgroundColor(serie),
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <TextInput
          value={propertyString}
          onChangeText={handleChange}
          // onFocus={() =>
          //   serie.exercise.workout.setSelectedExercise(serie.exercise)
          // }
          inputMode={isTargetCase ? "text" : "numeric"}
          style={{
            width: "100%",
            height: 24,
            borderRadius: screenSize === "small" ? 8 : 10,
            textAlign: "center",
            color: "black",
            fontSize: screenSize === "small" ? 10.5 : 11,
          }}
          maxLength={10}
        />
      </View>
    );
  };

  const copyTargetToActual = () => {
    serie.copyTargetToActual();
    setRefresh(!refresh);
  };

  const duplicateSerieBelow = () => {
    serie.exercise.duplicateSerieBelow(serie);
  };

  const Circles = () => {
    const [circlesMenu, setCirclesMenu] = useState(false);
    const showCirclesMenu = () => setCirclesMenu(true);

    const handleMenuItemPress = (relevance) => {
      serie.setProperty("relevance", relevance);
      setCirclesMenu(false);
    };

    const [isHovered, setIsHovered] = useState(false);

    const MenuItemView = ({ option }) => {
      const [isHovered, setIsHovered] = useState(false);

      return option === 1 ? (
        <MenuItem
          onPress={() => handleMenuItemPress(1)}
          style={{ minWidth: 160 }}
          textStyle={{
            fontSize: 14,
            color: Colors.blackColor,
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={[
              GlobalStyles.circle,
              { backgroundColor: "red", borderWidth: 0.2 },
            ]}
          />

          <Text style={{ marginLeft: 6 }}>{t("highPriority-string")}</Text>
        </MenuItem>
      ) : option === 2 ? (
        <MenuItem
          onPress={() => handleMenuItemPress(2)}
          style={{ minWidth: 160 }}
          textStyle={{
            fontSize: 14,
            color: Colors.blackColor,
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={[
              GlobalStyles.circle,
              { backgroundColor: "yellow", borderWidth: 0.2 },
            ]}
          />

          <Text style={{ marginLeft: 6 }}>{t("mediumPriority-string")}</Text>
        </MenuItem>
      ) : (
        <MenuItem
          onPress={() => handleMenuItemPress(3)}
          style={{ minWidth: 160 }}
          textStyle={{
            fontSize: 14,
            color: Colors.blackColor,
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={[
              GlobalStyles.circle,
              { backgroundColor: "green", borderWidth: 0.2 },
            ]}
          />
          <Text style={{ marginLeft: 6 }}>{t("lowPriority-string")}</Text>
        </MenuItem>
      );
    };

    return (
      <Menu
        visible={circlesMenu}
        anchor={
          <Tooltip
            content="setPriority-string"
            placement="top"
            delayedOpen={true}
            disabled={circlesMenu}
          >
            <TouchableOpacity
              style={{ opacity: isHovered ? 0.5 : 1 }}
              onPress={showCirclesMenu}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <View
                style={[
                  GlobalStyles.circle,
                  {
                    backgroundColor:
                      serie.relevance === 1
                        ? "red"
                        : serie.relevance === 2
                        ? "yellow"
                        : "green",
                    borderWidth: 0.2,
                  },
                ]}
              />
            </TouchableOpacity>
          </Tooltip>
        }
        style={GlobalStyles.menu}
        onRequestClose={() => setCirclesMenu(false)}
      >
        <MenuItemView option={1} />
        <MenuItemView option={2} />
        <MenuItemView option={3} />
      </Menu>
    );
  };

  const VideoView = observer(() => {
    const [circlesMenu, setCirclesMenu] = useState(false);

    async function handleVideoPress() {
      if (serie.hasVideo) {
        const coach = serie?.exercise?.workout?.block?.client?.coach;
        if (coach && !coach.isOffline) {
          const mediaManager = MediaManager.getInstance();
          mediaManager.showMediaPlayer(undefined, serie);
        }
      } else {
        if (serie.requireVideo) {
          serie.setProperty("requireVideo", false);
        } else {
          serie.setProperty("requireVideo", true);
        }
      }
    }

    const handleMenuItemPress = (relevance) => {
      serie.setProperty("relevance", relevance);
      setCirclesMenu(false);
    };

    const [isHovered, setIsHovered] = useState(false);

    const MenuItemView = ({ option }) => {
      const [isHovered, setIsHovered] = useState(false);

      return option === 1 ? (
        <MenuItem
          onPress={() => handleMenuItemPress(1)}
          style={{ minWidth: 160 }}
          textStyle={{
            fontSize: 14,
            color: Colors.blackColor,
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={[
              GlobalStyles.circle,
              { backgroundColor: "red", borderWidth: 0.2 },
            ]}
          />

          <Text style={{ marginLeft: 6 }}>{t("highPriority-string")}</Text>
        </MenuItem>
      ) : option === 2 ? (
        <MenuItem
          onPress={() => handleMenuItemPress(2)}
          style={{ minWidth: 160 }}
          textStyle={{
            fontSize: 14,
            color: Colors.blackColor,
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={[
              GlobalStyles.circle,
              { backgroundColor: "yellow", borderWidth: 0.2 },
            ]}
          />

          <Text style={{ marginLeft: 6 }}>{t("mediumPriority-string")}</Text>
        </MenuItem>
      ) : (
        <MenuItem
          onPress={() => handleMenuItemPress(3)}
          style={{ minWidth: 160 }}
          textStyle={{
            fontSize: 14,
            color: Colors.blackColor,
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={[
              GlobalStyles.circle,
              { backgroundColor: "green", borderWidth: 0.2 },
            ]}
          />
          <Text style={{ marginLeft: 6 }}>{t("lowPriority-string")}</Text>
        </MenuItem>
      );
    };

    return (
      <Menu
        visible={circlesMenu}
        anchor={
          <Tooltip
            content={
              serie.hasVideo
                ? ""
                : serie.requireVideo
                ? "dontRequestVideo-string"
                : "requestVideo-string"
            }
            placement="top"
            delayedOpen={true}
            disabled={serie.hasVideo}
          >
            <TouchableOpacity
              style={{ opacity: isHovered ? 0.5 : 1 }}
              onPress={handleVideoPress}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Ionicons
                name={
                  serie.hasVideo
                    ? "videocam"
                    : serie.requireVideo
                    ? "videocam-outline"
                    : "videocam-off-outline"
                }
                size={screenSize === "large" ? 20 : 16}
                color={
                  serie.hasVideo || serie.requireVideo
                    ? "black"
                    : "rgba(0, 0, 0, 0.2)"
                }
                style={{
                  marginRight: screenSize !== "small" && -4,
                }}
              />
            </TouchableOpacity>
          </Tooltip>
        }
        style={GlobalStyles.menu}
        onRequestClose={() => setCirclesMenu(false)}
      >
        <MenuItemView option={1} />
        <MenuItemView option={2} />
        <MenuItemView option={3} />
      </Menu>
    );
  });

  const CopyTargetButton = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <Tooltip
        content="copyTargetToActual-string"
        placement="top"
        delayedOpen={true}
      >
        <TouchableOpacity
          onPress={copyTargetToActual}
          style={{ paddingLeft: 1 }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Ionicons
            name={
              isHovered
                ? "arrow-forward-circle"
                : "arrow-forward-circle-outline"
            }
            size={screenSize === "large" ? 24 : 20}
            color={Colors.bubbleColor}
          />
        </TouchableOpacity>
      </Tooltip>
    );
  };

  const DuplicateSerieBelowButton = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <Tooltip
        content="copyToNextSet-string"
        placement="top"
        delayedOpen={true}
      >
        <TouchableOpacity
          onPress={duplicateSerieBelow}
          style={{ opacity: isHovered ? 0.5 : 1 }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <MaterialCommunityIcons
            name="arrow-down-right"
            size={screenSize == "large" ? 20 : 16}
            color={Colors.bubbleColor}
            style={{
              marginLeft: screenSize !== "small" && -4,
            }}
          />
        </TouchableOpacity>
      </Tooltip>
    );
  };

  const DeleteSerieButton = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <Tooltip content="deleteSet-string" placement="top" delayedOpen={true}>
        <TouchableOpacity
          onPress={() => serie.exercise.deleteSerie(serie)}
          style={{ opacity: isHovered ? 0.5 : 1 }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Feather
            name="x"
            size={screenSize == "large" ? 20 : 16}
            color={Colors.bubbleColor}
          />
        </TouchableOpacity>
      </Tooltip>
    );
  };

  return (
    <View>
      <View
        style={{
          width: "100%",
          alignItems: "center",
          flexDirection: "row",
          justifyContent:
            screenSize == "large" ? "space-between" : "space-around",
          marginBottom: 5,
          paddingHorizontal: screenSize == "large" ? 12 : 4,
        }}
      >
        <View
          style={{
            width: showSetPriority ? "8%" : "4%",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "space-around",
          }}
        >
          {showSetPriority && <Circles />}
          <VideoView />
        </View>
        <TextBox
          property={serie.targetWeight}
          propertyCase={PropertyCases.targetWeight}
        />
        <TextBox
          property={serie.targetReps}
          propertyCase={PropertyCases.targetReps}
        />
        <TextBox
          property={serie.targetRpe}
          propertyCase={PropertyCases.targetRpe}
        />
        <View
          style={{
            width: screenSize === "small" ? "6%" : "5%",
            alignItems: "center",
          }}
        >
          <CopyTargetButton />
        </View>
        <TextBox property={serie.weight} propertyCase={PropertyCases.weight} />
        <TextBox property={serie.reps} propertyCase={PropertyCases.reps} />
        <TextBox property={serie.rpe} propertyCase={PropertyCases.rpe} />
        <View
          style={{
            width: screenSize === "small" ? "5%" : "8%",
            justifyContent: "space-around",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <DuplicateSerieBelowButton />
          {screenSize != "small" && <DeleteSerieButton />}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  exerciseTitle: {
    //marginVertical: 30,
    //   paddingTop: 30,
  },
  targetActual: {
    paddingHorizontal: 20,
    paddingTop: 10,
  },
  textBoxContainer: {
    width: 60,
    height: 30,
    //marginHorizontal: 8,
    marginVertical: 8,
    //backgroundColor: "white",
    borderRadius: 9,
    justifyContent: "center",
    alignItems: "center",
    // borderWidth: 2,
    textAlign: "center",
  },
  zStack: {
    width: 60,
    height: 30,
    //marginHorizontal: 8,
    marginVertical: 8,
    // backgroundColor: "red",
    borderRadius: 9,
  },
  underline: {
    height: 2, // Thickness of the underline
    width: "100%", // Ensure it spans the full width of the text
    alignSelf: "center", // Ensure it matches the width of the text, not the container
    marginTop: 5, // Spacing between the text and the underline
  },
  exerciseTitle: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 20,
  },
  addButton: {
    padding: 10,
    height: 30,
    marginVertical: 8,
    marginHorizontal: 10,
    borderRadius: 9,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginBottom: 24,
  },

  //STOPWATCH
  StopwatchContainer: {
    marginVertical: 40,
    alignItems: "center",
    flexDirection: "row",
    paddingLeft: 15,
    paddingRight: 15,
    // backgroundColor: "white",
    // marginBottom: 10,
    marginHorizontal: 10,
    // shadowColor: "black",
    borderRadius: 10,
    elevation: 6,
  },
  separator: {
    width: 1,
    height: 30,
    backgroundColor: Colors.grayColor,
    opacity: 0.5,
    marginRight: 15,
  },

  //STATISTICS ROW VIEW
  background: {
    height: 60,
    // backgroundColor: "white", // Assuming you have this color defined elsewhere
    borderRadius: 10,
    paddingHorizontal: 10,
    justifyContent: "center",
    shadowLayer: {
      backgroundColor: "rgba(0,0,0,0.1)", // Adjust this for shadow color
      position: "absolute",
      top: 3,
      bottom: 3,
      left: 3,
      right: 3,
      borderRadius: 10,
    },
    shadowColor: Colors.bubbleColor, // Assuming you have this color defined elsewhere
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.5,
    shadowRadius: 1,
    elevation: 1,
    marginHorizontal: 10, // Corresponds to .padding(.horizontal) in SwiftUI
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  statisticsRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  statisticLabel: {
    fontSize: 15,
  },
  statisticValue: {
    flex: 1,
    fontSize: 15,
    fontWeight: "500", // Medium weight
    marginLeft: 5,
    marginRight: 20,
  },

  //EXERCISE NOTES
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  headerText: {
    fontSize: 20,
    fontWeight: "bold",
    paddingVertical: 12,
  },
  inputBackground: {
    backgroundColor: "red",
    lexDirection: "row",
    flex: 1,
    justifyContent: "center",
    maxLength: 1000,
  },
  input: {
    borderRadius: 10,

    // height: 100,
    // flex: 1,
    // backgroundColor: "red",
    // padding: 10,
    //color: "black",

    // textAlignVertical: "top", // This is for Android. It aligns the text to the top.
    // placeholderTextColor: "gray", // This sets the placeholder color
  },

  buttonContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginVertical: 16,
  },
  button: {
    paddingVertical: 8,
    paddingHorizontal: 20,
    borderRadius: 8,
    backgroundColor: "rgba(0,0,0,0.1)",
    marginHorizontal: 10,
  },
  targetButton: {
    marginRight: 50,
  },
  realButton: {},
  input: {
    borderWidth: 1,
    borderColor: "gray",
    borderRadius: 8,
    padding: 10,
    margin: 10,
    width: 200,
  },
});

export default SerieRowView;
